import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';

import AppState from '../app/store/state';
import ActivityLogsList from '../activityLogs/ActivityLogsList';
import { ActionCreators as ManagerActionCreators } from '../managers/managers';
import { ActionCreators as VendorActionCreators } from '../vendors/vendors';
import { ManagerPermission } from '../permission-profiles/permission';
import { ActionCreators as PartnerActionCreators } from '../partners/partnersActions';

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return {
        loadActivityLogs: (page, limit, managerId) =>
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (dispatch as any)(ManagerActionCreators.loadActivityLogs(managerId, page, limit)),
        loadManagersNickNames: bindActionCreators(ManagerActionCreators.loadManagersNickNames, dispatch),
        loadVendorsNickNames: bindActionCreators(VendorActionCreators.loadVendorsNickNames, dispatch),
        loadVendorUsersNames: bindActionCreators(VendorActionCreators.loadVendorUsersNames, dispatch),
        loadPartnersNames: bindActionCreators(PartnerActionCreators.loadPartnersNames, dispatch),
        loadPartnerUserNames: bindActionCreators(PartnerActionCreators.loadPartnerUsersName, dispatch),
        isManager: true,
    };
}

function mapStateToProps(state: AppState) {
    return {
        activityLogs: state.managers.activityLogs,
        managersNickNames: state.managers.managerNickNameList,
        vendorsNickNames: state.vendors.nickNameList,
        partnersNickNames: state.partners.nameList,
        partnerUsersNickNames: state.partners.partnerUsersNamesList,
        auth: state.auth,
        url: state.auth.manager ? `/admin/${state.auth.manager.id}/export-activity-log` : `/login`,
        downloadRestriction: [ManagerPermission.userActivityDownload],
        vendorUsersNames: state.vendors.usersNames,
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null)(ActivityLogsList);
